import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ClosingSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-10 md:py-24 px-4 bg-white" data-id="element-28">
      <div className="max-w-5xl mx-auto" data-id="element-29">
        <div className="text-center mb-8 md:mb-16" data-id="element-30">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-teal-dark mb-4" data-id="element-31">
            Tienes dos caminos frente a ti:
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-8 md:mb-16" data-id="element-32">
          {/* Camino A */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gray-50 border border-gray-200 p-5 md:p-8 rounded-2xl opacity-80" data-id="element-33">
            <div className="flex items-center gap-3 mb-6" data-id="element-34">
              <XCircle className="w-8 h-8 text-gray-400" data-id="element-35" />
              <h3 className="text-2xl font-bold text-gray-500" data-id="element-36">Camino A</h3>
            </div>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-37">
              Seguir despertando con el mismo peso en el pecho, dejando que el
              mundo dicte tu estado de ánimo y esperando que las cosas cambien
              por arte de magia.
            </p>
          </motion.div>

          {/* Camino B */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-teal-dark text-white p-5 md:p-8 rounded-2xl shadow-xl border-2 border-gold relative overflow-hidden" data-id="element-38">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold rounded-full blur-3xl opacity-20" data-id="element-39"></div>
            <div className="flex items-center gap-3 mb-6 relative z-10" data-id="element-40">
              <CheckCircle className="w-8 h-8 text-gold-light" data-id="element-41" />
              <h3 className="text-2xl font-bold text-gold-light" data-id="element-42">Camino B</h3>
            </div>
            <p className="text-lg text-white/90 leading-relaxed relative z-10" data-id="element-43">
              Tomar autoridad sobre tu mañana, implementar el Protocolo y
              empezar a vivir la Vida Eterna hoy mismo.
            </p>
          </motion.div>
        </div>

        <div className="text-center max-w-3xl mx-auto" data-id="element-44">
          <CTAButton text="¡SÍ! QUIERO MI PROTOCOLO Y MIS 4 BONUSES AHORA" onClick={scrollToPricing} className="w-full text-xl py-5 shadow-2xl" data-id="element-45" />
        </div>
      </div>
    </section>;
}